import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetProjectFeeResponse } from "../../../../api/services/project/model";
import {
  useGetProjectFeeDetails,
  useGetProjectFeesAndExpenses,
} from "../../../../api/services/project/projectApis";
import { MuiModal } from "../../../../components";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import {
  toggleLoader,
  toggleToast,
} from "../../../../redux/slices/appState/appStateSlice";
import { ViewProjectFee } from "../../../viewProject/components/viewProjectFee/ViewProjectFee";
import { projectFeeDetailsCoreKeys } from "../../siteCore/SiteCoreKeys";

interface ViewProjectFeeModalProps {
  open: boolean;
  onClose: () => void;
  projectId: string;
}

const pageId = COMPONENT_IDS.VIEW_PROGRAM_FEE_MODAL;

export const ViewProjectFeeModal: FC<ViewProjectFeeModalProps> = ({
  open,
  onClose,
  projectId,
}) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  const dispatch = useDispatch();

  const {
    data: projectFeeDetailsData,
    isFetching: isProjectFeeDetailsPending,
    isError: isProjectFeeDetailsError,
    refetchWithParams: getProjectFeeByProjectId,
  } = useGetProjectFeeDetails();

  const {
    data: generalDetail,
    isError: isProjectError,
    isPending: isProjectFetching,
  } = useGetProjectFeesAndExpenses();

  useEffect(() => {
    getProjectFeeByProjectId(projectId);
  }, [projectId]);

  useEffect(() => {
    if (isProjectError || isProjectFeeDetailsError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
      dispatch(toggleLoader({ isVisible: false }));
    }
  }, [isProjectError, isProjectFeeDetailsError]);

  useEffect(() => {
    dispatch(
      toggleLoader({
        isVisible: isProjectFetching || isProjectFeeDetailsPending,
        message: commonLabels.loadingPleaseWait,
      }),
    );
    return () => {
      dispatch(toggleLoader({ isVisible: false }));
    };
  }, [isProjectFetching, isProjectFeeDetailsPending]);

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      title={fetchLabel(
        projectFeeDetailsCoreKeys.projectFeeDetails,
        projectFeeDetailsCoreKeys.viewProjectFeeHeader,
      )}
      hasLargeContent
      showPrimaryButton={false}
      showSecondaryButton={true}
      secondaryButtonTitle={commonLabels.close}
      onSecondaryButtonClick={onClose}
    >
      <ViewProjectFee
        projectFeeDetailsData={
          projectFeeDetailsData || ({} as GetProjectFeeResponse)
        }
        clientId=""
        programTemplateId=""
        pageId={pageId}
      />
    </MuiModal>
  );
};
